import VitalList from './vital-list';

export default VitalList;
